import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { motionOk } from "../lib/motionOk.js";
import { useLang } from "../i18n.jsx";

export default function FaqSection() {
  const [open, setOpen] = useState(0);
  const { content } = useLang();
  const { faqs, faqHead } = content;
  return (
    <section id="faq" className="relative px-6 py-20">
      <div className="mx-auto max-w-3xl">
        <motion.div
          initial={motionOk ? { opacity: 0, y: 24 } : false}
          whileInView={motionOk ? { opacity: 1, y: 0 } : undefined}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="text-center"
        >
          <p className="mb-4 text-[12px] uppercase tracking-[0.3em] text-acid">{faqHead.eyebrow}</p>
          <h2 className="font-display font-extrabold tracking-tight text-[clamp(1.8rem,4.2vw,3rem)] leading-[1.08]">{faqHead.title}</h2>
        </motion.div>

        <div className="mt-12 divide-y divide-paper/10 border-y border-paper/10">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i}>
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  data-cursor
                  className="flex w-full items-center justify-between gap-4 py-5 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="font-display text-lg font-bold tracking-tight text-paper">{f.q}</span>
                  <motion.span
                    animate={motionOk ? { rotate: isOpen ? 45 : 0 } : undefined}
                    className="grid place-items-center w-9 h-9 shrink-0 rounded-full border border-paper/15 text-paper/70"
                  >
                    <Plus className="w-4 h-4" />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={motionOk ? { height: 0, opacity: 0 } : false}
                      animate={motionOk ? { height: "auto", opacity: 1 } : undefined}
                      exit={motionOk ? { height: 0, opacity: 0 } : undefined}
                      transition={{ duration: 0.32, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="pb-6 pr-10 text-[15px] text-paper/70 leading-relaxed">{f.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}